import { createSlice } from '@reduxjs/toolkit';

type DeepLinkingState = {
  path: string | undefined;
};

const initialState: DeepLinkingState = {
  path: undefined,
};

// o path pode chegar já codificado (window.location.pathname) ou não (Linking);
// decodifica antes de codificar para nunca gerar %25 em cima de %
export const normalizeDeepLinkPath = (path: string) => {
  try {
    return encodeURI(decodeURI(path));
  } catch {
    return encodeURI(path);
  }
};

const extractPathFromUrl = (url: string) => {
  try {
    const parsed = new URL(url);

    const cleanPath = `${parsed.host}${parsed.pathname}`
      .replace(/^www\.bandplay\.com\//, '')
      .replace(/^\/+/, '');

    return normalizeDeepLinkPath(cleanPath);
  } catch {
    const customUrl = url
      .replace(/^bandplay:\/\//, '')
      .replace(/^https?:\/\/(www\.)?bandplay\.com\//, '')
      .replace(/^\/+/, '');

    return normalizeDeepLinkPath(customUrl);
  }
};

const deepLinkingSlice = createSlice({
  name: 'deepLinkingSlice',
  initialState,
  reducers: {
    setDeepLinkingPath: (state, { payload }) => {
      state.path = extractPathFromUrl(payload.path);
    },
    deleteDeepLinkingPath: (state) => {
      state.path = undefined;
    },
  },
});

export const { setDeepLinkingPath, deleteDeepLinkingPath } = deepLinkingSlice.actions;
export default deepLinkingSlice.reducer;
